import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-md-2" }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = { class: "col-md-1" }
const _hoisted_6 = { class: "col-md-1" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "col-md-2 d-flex align-items-end" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "ms-3" }
const _hoisted_13 = { class: "details" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "response" }
const _hoisted_18 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_19 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_33 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[24] || (_cache[24] = _createElementVNode("h1", null, "Обращения LMS", -1)),
    _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-muted" }, "Кто, когда и какой файл прислал через API интеграции и что мы ответили. Присланные файлы можно скачать.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "LMS", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.lmsName) = $event)),
          placeholder: "INDIGO, Bilimal…"
        }, null, 512), [
          [_vModelText, _ctx.params.lmsName]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Пользователь", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.username) = $event))
        }, null, 512), [
          [_vModelText, _ctx.params.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Месяц", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "1",
          max: "12",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.accountingMonth) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.params.accountingMonth,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Год", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          min: "2024",
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.accountingYear) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.params.accountingYear,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "С", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fromDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.fromDate]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "По", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.toDate]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.onlyErrors) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.params.onlyErrors]
          ]),
          _cache[15] || (_cache[15] = _createTextVNode(" Только ошибки"))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fetch(true))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.loading ? "Загрузка..." : "Поиск"), 9, _hoisted_11),
      _createElementVNode("span", _hoisted_12, "Найдено: " + _toDisplayString(_ctx.total), 1)
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.total,
      "per-page": _ctx.params.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createVNode(_component_el_table, {
      data: _ctx.rows,
      style: {"width":"100%"},
      border: "",
      "row-class-name": _ctx.rowClassName,
      "row-key": "entry.id",
      onExpandChange: _ctx.onExpand
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx((props) => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("b", null, "Запрос:", -1)),
                _createTextVNode(" " + _toDisplayString(props.row.entry.method) + " " + _toDisplayString(props.row.entry.path), 1),
                (props.row.entry.queryString)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "?" + _toDisplayString(props.row.entry.queryString), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("b", null, "IP:", -1)),
                _createTextVNode(" " + _toDisplayString(props.row.entry.ip) + " · ", 1),
                _cache[18] || (_cache[18] = _createElementVNode("b", null, "request_id:", -1)),
                _createTextVNode(" " + _toDisplayString(props.row.entry.requestId) + " · ", 1),
                _cache[19] || (_cache[19] = _createElementVNode("b", null, "время ответа:", -1)),
                _createTextVNode(" " + _toDisplayString(props.row.entry.durationMs) + " мс", 1)
              ]),
              _createElementVNode("div", null, [
                _cache[20] || (_cache[20] = _createElementVNode("b", null, "Сохранён как:", -1)),
                _createTextVNode(" " + _toDisplayString(props.row.entry.storedPath || "—"), 1)
              ]),
              (props.row.entry.bin || props.row.entry.lmsId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[21] || (_cache[21] = _createElementVNode("b", null, "Садик:", -1)),
                    _createTextVNode(" БИН " + _toDisplayString(props.row.entry.bin || "—") + " · lms_id " + _toDisplayString(props.row.entry.lmsId || "—") + " · регион " + _toDisplayString(props.row.region || "—"), 1)
                  ]))
                : (props.row.kindergartenCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[22] || (_cache[22] = _createElementVNode("b", null, "Садиков в файле:", -1)),
                      _createTextVNode(" " + _toDisplayString(props.row.kindergartenCount) + " · регион " + _toDisplayString(props.row.region || (props.row.regionCount > 1 ? `несколько (${props.row.regionCount})` : "—")), 1)
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("b", null, "Наш ответ (" + _toDisplayString(props.row.entry.status) + "):", 1)
              ]),
              _createElementVNode("pre", _hoisted_17, _toDisplayString(props.row.entry.responseBody), 1),
              (_ctx.results[props.row.entry.id])
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[23] || (_cache[23] = _createElementVNode("b", null, "Обработка из очереди по садикам:", -1)),
                    _createVNode(_component_el_table, {
                      data: _ctx.results[props.row.entry.id],
                      size: "small",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "Когда",
                          width: "150"
                        }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(s.row.result.occurredAt)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "БИН",
                          width: "125"
                        }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(s.row.bin || "—"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "lms_id",
                          width: "110"
                        }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(s.row.result.lmsId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Регион",
                          width: "150"
                        }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(s.row.region || "—"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Этап",
                          width: "110"
                        }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(s.row.result.stage === "UPLOAD" ? "Сохранение" : "Расчёт"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Итог",
                          width: "80"
                        }, {
                          default: _withCtx((s) => [
                            _createElementVNode("span", {
                              class: _normalizeClass(s.row.result.status === 'OK' ? 'text-success' : 'text-danger')
                            }, _toDisplayString(s.row.result.status), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "Сообщение" }, {
                          default: _withCtx((s) => [
                            _createTextVNode(_toDisplayString(s.row.result.message), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["data"]),
                    (_ctx.results[props.row.entry.id].length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Итогов из очереди пока нет."))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Когда",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.entry.occurredAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "LMS",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.entry.lmsName || "—"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Пользователь",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.entry.username || "— (без токена)"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Что прислали",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.endpointLabel(scope.row.entry.path)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Период",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            (scope.row.entry.accountingMonth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.entry.accountingMonth) + "/" + _toDisplayString(scope.row.entry.accountingYear), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Тип табеля",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.timesheetTypeLabel(scope.row.entry.timesheetType)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "БИН",
          width: "125"
        }, {
          default: _withCtx((scope) => [
            (scope.row.entry.bin)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row.entry.bin), 1))
              : (scope.row.kindergartenCount > 0)
                ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_ctx.kindergartensLabel(scope.row.kindergartenCount)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "lms_id",
          width: "110"
        }, {
          default: _withCtx((scope) => [
            (scope.row.entry.lmsId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row.entry.lmsId), 1))
              : (scope.row.kindergartenCount > 0)
                ? (_openBlock(), _createElementBlock("small", _hoisted_25, "см. строку ▸"))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, "—"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Регион",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            (scope.row.region)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(scope.row.region), 1))
              : (scope.row.regionCount > 1)
                ? (_openBlock(), _createElementBlock("small", _hoisted_28, "несколько (" + _toDisplayString(scope.row.regionCount) + ")", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Файл" }, {
          default: _withCtx((scope) => [
            (scope.row.entry.storedPath)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.download(scope.row.entry)), ["prevent"])
                }, _toDisplayString(scope.row.entry.fileName), 9, _hoisted_30))
              : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(scope.row.entry.fileName || "—"), 1)),
            (scope.row.entry.fileSize)
              ? (_openBlock(), _createElementBlock("small", _hoisted_32, " (" + _toDisplayString(_ctx.formatSize(scope.row.entry.fileSize)) + ")", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Ответ",
          width: "220"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: _normalizeClass(scope.row.entry.status >= 400 ? 'text-danger' : 'text-success')
            }, _toDisplayString(scope.row.entry.status), 3),
            _createElementVNode("small", null, _toDisplayString(_ctx.shorten(scope.row.entry.responseBody)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Обработка",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("small", {
              innerHTML: _ctx.processingLabel(scope.row)
            }, null, 8, _hoisted_33)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name", "onExpandChange"])
  ]))
}